import 'semantic-ui-css/components/icon.min.css';
import 'semantic-ui-css/components/modal.min.css';
import './reset.css';
import './semantic-ui-overrides.css';
export default {
    break: {
        tinyAlt: '479px',
        tiny: '480px',
        small: '767px',
        medium: '1024px',
        mediumAlt: '1023px',
        largeHD: '1279px',
        large: '1439px',
        largeXHD: '1599px',
        largeFHD: '1919px',
    },
    height: {
        small: '767px',
        medium: '899px',
        large: '1079px',
    },
    color: {
        yellow: '#FECF00',
        yellowHover: '#FFDF52',
        red: '#D0021B',
        redHover: '#B5061B',
        green: '#2FB457',
        blue: '#5384EC',
        blueHover: '#1F60EC',
        white: '#FFF',
        light: '#F8F8F8',
        fade: '#EEE',
        medium: '#4C4D52',
        mediumHover: '#6A6D78',
        lightGrey: '#DDD',
        grey: '#ADADAD',
        darker: '#1F2027',
        black: '#000',
        borderSection: '#CCC',
        borderInput: '#DDD',
        // Text
        subtext: '#777',
        // Status
        success: '#2FB457',
        error: '#D0021B',
        warning: '#FC8527',
        // Role
        member: '#EA4B89',
        viewer: '#EE4B3E',
        admin: '#277BEB',
        owner: '#1F2027',
        contributor: '#4C4D52',
        creator: '#3E9296',
        manager: '#5A339F',
        publisher: '#587291',
        info: '#1F2027',
        selected: '#42B6FB',
        shadow: 'rgba(0, 0, 0, .4)',
    },
    default: {
        borderRadius: 'border-radius: 4px',
        actionBorderRadius: 'border-radius: 4px',
        cardBorderRadius: 'border-radius: 6px',
        actionHeight: 'height: 45px',
        actionHeightMobile: 'height: 38px',
        horizontalPadding: '10px',
        verticalPadding: '10px',
        horizontalMargin: '10px',
        verticalMargin: '10px',
    },
    sidebar: {
        minWidth: '70px',
        maxWidth: '240px',
    },
    sidebarRight: {
        minWidth: '260px',
        maxWidth: '320px',
        smallMaxWidth: '260px',
    },
    admin: {
        desktopHorizontalPadding: '20px',
        mobileHorizontalPadding: '12px',
        desktopVerticalPadding: '20px',
        mobileVerticalPadding: '12px',
        desktopVerticalMargin: '24px',
        mobileVerticalMargin: '16px',
        header: {
            desktopHeight: '70px',
            mobileHeight: '64px',
        },
        nav: {
            desktopHeight: '60px',
            mobileHeight: '50px',
        },
    },
    subheader: {
        styled: "\n    span,\n    .button {\n      text-transform: uppercase;\n      color: #ADADAD;\n      z-index: 1;\n      position: relative;\n      height: 40px;\n      font-size: 12px;\n      display: inline-flex;\n      align-items: center;\n      letter-spacing: 0.1em;\n      line-height: 1;\n      font-weight: 900;\n\n      i {\n        width: 8px;\n        margin-left: 5px;\n        height: 4px;\n        background-color: #ADADAD;\n      }\n    }\n    ",
    },
};
//# sourceMappingURL=theme.config.js.map